import { gql } from '@apollo/client';

export const updateLicenseTypeMutation = gql`
  mutation ($pk_columns: license_types_pk_columns_input!, $set: license_types_set_input!) {
    update_license_types_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
  }
`;
